(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './projects-core-koin-core.js', './androidx-compose-runtime-runtime.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./projects-core-koin-core.js'), require('./androidx-compose-runtime-runtime.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'projects-compose-koin-compose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'projects-compose-koin-compose'.");
    }
    if (typeof globalThis['projects-core-koin-core'] === 'undefined') {
      throw new Error("Error loading module 'projects-compose-koin-compose'. Its dependency 'projects-core-koin-core' was not found. Please, check whether 'projects-core-koin-core' is loaded prior to 'projects-compose-koin-compose'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'projects-compose-koin-compose'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'projects-compose-koin-compose'.");
    }
    globalThis['projects-compose-koin-compose'] = factory(typeof globalThis['projects-compose-koin-compose'] === 'undefined' ? {} : globalThis['projects-compose-koin-compose'], globalThis['kotlin-kotlin-stdlib'], globalThis['projects-core-koin-core'], globalThis['androidx-compose-runtime-runtime']);
  }
}(function (_, kotlin_kotlin, kotlin_io_insert_koin_koin_core, kotlin_androidx_compose_runtime_runtime) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var KoinPlatform_instance = kotlin_io_insert_koin_koin_core.$_$.c;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var Exception = kotlin_kotlin.$_$.gn;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ComposeContextWrapper, 'ComposeContextWrapper', ComposeContextWrapper);
  //endregion
  var org_koin_compose_ComposeContextWrapper$stable;
  function ComposeContextWrapper(initValue, setValue) {
    initValue = initValue === VOID ? null : initValue;
    setValue = setValue === VOID ? null : setValue;
    this.axl_1 = setValue;
    this.bxl_1 = initValue;
  }
  protoOf(ComposeContextWrapper).cxl = function () {
    var tmp = this;
    var tmp0_safe_receiver = this.axl_1;
    tmp.bxl_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    return this.bxl_1;
  };
  protoOf(ComposeContextWrapper).dxl = function () {
    if (this.bxl_1 == null) {
      var tmp = this;
      var tmp0_safe_receiver = this.axl_1;
      tmp.bxl_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    }
    var tmp1_elvis_lhs = this.bxl_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "Can't retrieve Koin context value. Ensure Koin is properly initialized with startKoin() or KoinApplication.";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  var LocalKoinScope;
  var LocalKoinApplication;
  function get_LocalKoinScopeContext() {
    _init_properties_KoinApplication_kt__lzwtrf();
    return LocalKoinScopeContext;
  }
  var LocalKoinScopeContext;
  var LocalKoinApplicationContext;
  function getDefaultRootScope() {
    _init_properties_KoinApplication_kt__lzwtrf();
    return KoinPlatform_instance.vs6().es2_1.ns2_1;
  }
  function getDefaultKoinContext() {
    _init_properties_KoinApplication_kt__lzwtrf();
    return KoinPlatform_instance.vs6();
  }
  function currentKoinScope($composer, $changed) {
    _init_properties_KoinApplication_kt__lzwtrf();
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1668867238, 'C(currentKoinScope):KoinApplication.kt#8jjlyv');
    if (isTraceInProgress()) {
      traceEventStart(1668867238, $changed, -1, 'org.koin.compose.currentKoinScope (KoinApplication.kt:105)');
    }
    // Inline function 'kotlin.run' call
    var tmp;
    try {
      var currentScope = $composer_0.u31(get_LocalKoinScopeContext()).dxl();
      var tmp_0;
      if (currentScope.k4b()) {
        var tmp0_elvis_lhs = $composer_0.u31(get_LocalKoinScopeContext()).cxl();
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "Can't get Koin scope. Scope '" + currentScope.toString() + "' is closed";
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = currentScope;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception) {
        var e = $p;
        var tmp1_elvis_lhs = $composer_0.u31(get_LocalKoinScopeContext()).cxl();
        var tmp_3;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message_0 = "Can't get Koin scope due to error: " + e.toString();
          throw IllegalStateException_init_$Create$(toString(message_0));
        } else {
          tmp_3 = tmp1_elvis_lhs;
        }
        tmp_2 = tmp_3;
      } else {
        throw $p;
      }
      tmp = tmp_2;
    }
    var tmp0 = tmp;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function LocalKoinScope$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    // Inline function 'kotlin.error' call
    var message = 'should not be used in favor of LocalKoinScopeContext';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function LocalKoinApplication$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    // Inline function 'kotlin.error' call
    var message = 'should not be used in favor of getKoin()';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function LocalKoinScopeContext$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    var tmp = getDefaultRootScope();
    return new ComposeContextWrapper(tmp, LocalKoinScopeContext$lambda$lambda);
  }
  function LocalKoinScopeContext$lambda$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    return getDefaultRootScope();
  }
  function LocalKoinApplicationContext$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    var tmp = getDefaultKoinContext();
    return new ComposeContextWrapper(tmp, LocalKoinApplicationContext$lambda$lambda);
  }
  function LocalKoinApplicationContext$lambda$lambda() {
    _init_properties_KoinApplication_kt__lzwtrf();
    return getDefaultKoinContext();
  }
  var properties_initialized_KoinApplication_kt_xwamuh;
  function _init_properties_KoinApplication_kt__lzwtrf() {
    if (!properties_initialized_KoinApplication_kt_xwamuh) {
      properties_initialized_KoinApplication_kt_xwamuh = true;
      LocalKoinScope = compositionLocalOf(VOID, LocalKoinScope$lambda);
      LocalKoinApplication = compositionLocalOf(VOID, LocalKoinApplication$lambda);
      LocalKoinScopeContext = compositionLocalOf(VOID, LocalKoinScopeContext$lambda);
      LocalKoinApplicationContext = compositionLocalOf(VOID, LocalKoinApplicationContext$lambda);
    }
  }
  var org_koin_compose_application_CompositionKoinApplicationLoader$stable;
  var org_koin_compose_error_UnknownKoinContext$stable;
  var org_koin_compose_module_CompositionKoinModuleLoader$stable;
  var org_koin_compose_scope_CompositionKoinScopeLoader$stable;
  //region block: init
  org_koin_compose_ComposeContextWrapper$stable = 8;
  org_koin_compose_application_CompositionKoinApplicationLoader$stable = 8;
  org_koin_compose_error_UnknownKoinContext$stable = 8;
  org_koin_compose_module_CompositionKoinModuleLoader$stable = 8;
  org_koin_compose_scope_CompositionKoinScopeLoader$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = currentKoinScope;
  //endregion
  return _;
}));

//# sourceMappingURL=projects-compose-koin-compose.js.map
